import { useEffect } from 'react';

import { token } from '@atlaskit/tokens';

import { extractToken } from '../color-conversion';

// foreground colors need to autotransition to its inverse when surrounding background colors are changed and AA readability contrast no longer passes
// in the first iteration of autotransitioned foreground colors, we are only concerned about default text colors
// foreground colors can be any additional color layer that is stacked on the first color layer
// shareable terms include highlight and text colors
export const useAutoTransitioningColors = (
	backgroundColor: string,
	isReadableForegroundColor: (color: string) => boolean,
	foregroundColor: string,
	updateForegroundColor: (color: string) => void,
	defaultParameters?: {
		backgroundColor: string;
		textColor: string;
	},
): void => {
	useEffect(() => {
		// No need to do autotransition when background color is same as default BackgroundColor, e.g. theme color
		if (
			!isReadableForegroundColor(foregroundColor) &&
			backgroundColor !== defaultParameters?.backgroundColor
		) {
			const textColorToken = extractToken(foregroundColor);
			if (textColorToken === extractToken(token('color.text'))) {
				updateForegroundColor(token('color.text.inverse'));
			} else if (textColorToken === extractToken(token('color.text.inverse'))) {
				updateForegroundColor(token('color.text'));
			} else if (foregroundColor === defaultParameters?.textColor) {
				if (isReadableForegroundColor(token('color.text'))) {
					updateForegroundColor(token('color.text'));
				} else {
					updateForegroundColor(token('color.text.inverse'));
				}
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [backgroundColor]);
};
